module.exports = __webpack_public_path__ + "static/media/dz.7c2261f0.svg";